import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FuncionariosService from '../../../../services/funcionarios';
import CargosService from '../../../../services/cargos'



const FormCadFunc = () => {
    const [nome, setNome] = useState("");
    const [cpf, setCPF] = useState("");
    const [matricula, setMatricula] = useState("");
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [cargo, setCargo] = useState("");
    const [situacao, setSituacao] = useState("");
    const [error, setError] = useState([]);
    const [cargos, setCargos] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchCargos() {
        const response = await CargosService.listar();
        if (response.data.length >= 1) {
            setCargos(response.data);
        } else {
            setCargos([]);
        }
    }

    function mascararCPF(cpf) {
        if (!cpf) return "";
        cpf = cpf.replace(/\D/g, "");
        if (cpf.length <= 3) return cpf;
        if (cpf.length <= 6) return cpf.replace(/(\d{3})(\d{1,3})/, "$1.$2");
        if (cpf.length <= 9) return cpf.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
    }

    function normalizarCPF(cpf) {
        return cpf.replace(/\D/g, "");
    }
    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const func = await FuncionariosService.cadastro({
                nome: nome,
                cpf: normalizarCPF(cpf),
                matricula: matricula,
                email: email,
                senha: senha,
                cargo: cargo,
                situacao: situacao
            })
            if (func.data["_id"]) {
                setSucesso(true);
            }
            else {
                alert(func.data["error"]);
            }
        } catch (error) {
            setError("Deu algo errado no seu cadastro!")
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setCPF("");
        setMatricula("");
        setEmail("");
        setSenha("");
        setCargo("");
        setSituacao("");
        setError([]);
    }

    useEffect(() => {
        fetchCargos();
    }, []);

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={12}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={12} lg={3}>
                                <Col xs={12} lg={10}>
                                    <Form.Group className="mb-3" controlId="nome">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="nome"
                                            value={nome}
                                            onChange={e => setNome(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={2}>
                                    <Form.Group className="mb-3" controlId="matricula">
                                        <Form.Label>Matrícula</Form.Label>
                                        <Form.Control
                                            required
                                            type="number"
                                            name="matricula"
                                            value={matricula}
                                            onChange={e => setMatricula(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group className="mb-3" controlId="CPF">
                                        <Form.Label>CPF</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="cpf"
                                            value={mascararCPF(cpf)}
                                            onChange={(e) => {
                                                // remove tudo que não for número
                                                const apenasNumeros = e.target.value.replace(/\D/g, "");
                                                if (apenasNumeros.length > 11) {
                                                    apenasNumeros = apenasNumeros.slice(0, 11);
                                                }
                                                setCPF(apenasNumeros);
                                            }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs={12} lg={4}>
                                    <Form.Group controlId="selectSituacao">
                                        <Form.Label>Situação</Form.Label>
                                        <Form.Select required value={situacao} onChange={e => setSituacao(e.target.value)}>
                                            <option value="">SELECIONE</option>
                                            <option value="Ativo">Ativo</option>
                                            <option value="Demitido">Demitido</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group controlId="selectCargo">
                                        <Form.Label>Cargo</Form.Label>
                                        <Form.Select required value={cargo} onChange={e => setCargo(e.target.value)}>
                                            <option value="">SELECIONE</option>
                                            {cargos.map(carg => (
                                                <option key={carg.cargo} value={carg.cargo}>{carg.cargo}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="Email">
                                        <Form.Label>E-mail</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="senha">
                                        <Form.Label>Senha</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="senha"
                                            value={senha}
                                            onChange={e => setSenha(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                            </Row>
                            <Row>
                                <Col xs={12} lg={3}>
                                    <Button variant="success" type="submit">
                                        Cadastrar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >
                    </Row>
                    <br />
                    <Link to={'/rh/funcionarios'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                    <br />
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>Funcionário cadastrado com sucesso!</Alert>
                    <Button onClick={addNovo} variant="success" type="submit">
                        Adicionar outro
                    </Button>
                    <br /><br />
                    <Link to={'/rh/funcionarios/listar'}>
                        <Button variant="primary" type="button">
                            Ir para Listagem de Funcionários
                        </Button>
                    </Link>
                    <br /><br />
                    <Link to={'/rh/funcionarios'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Container>
            </Fragment>
        )
    }
}

export default FormCadFunc;